!function(window) {
let root = document.documentElement;
let dropbox;
var map;
var params;
var initialLoad = true;

function setHeaderHeight(){
    if($('header').innerHeight() > 0){
        root.style.setProperty('--header', $('header').innerHeight() + "px");
    } else {
        root.style.setProperty('--header', "0px");
    }
}

function iniFrame() {
    if(window.self !== window.top) {
        setTimeout(function(){
            $('#cookieDiv').remove();
        },1000);
        $('header').remove();
    }
    setHeaderHeight();
}

function getAllSelectedCheckboxes(){
    var allCheckboxes = {
        layers: []
    };
    var cnt1 = 0;
    var cnt2 = 0;
    $('.filtercheckbox').each(function(){
        if($(this).prop("checked")){
            allCheckboxes['layers'].push([$(this).val()]);
            cnt1++;
        }
    });
    return allCheckboxes;
}

function asideMenu(){
    $('.checkbox-wrap input[type="checkbox"]').on('click', function(e){
        $(this).prop("checked",$(this).prop("checked"));
        var parent = $(this).closest('.dropdown');
        if($(this).data('isparent') == 'parent'){
            if($(this).prop("checked")){
                $('.filtercheckbox',parent).prop("checked","checked");
            } else {
                $('.filtercheckbox',parent).prop("checked","");
            }
        }
        triggerMapChange();
    });
    $('.dropdown-toggle').on('click', function(){
        $(this).toggleClass('open')
        $(this).parent('.dropdown').toggleClass('show')
        $(this).parent('.dropdown').children('.dropdown-menu').toggleClass('show');
    });
}

function initialMapLoad(){
    params = new URLSearchParams(window.location.search);
    loadedLayers.forEach(element => {
        $('.filtercheckbox[value="'+element+'"]').prop("checked","checked");
    });
    if(params.get('baseMap') == '1'){
        $('.maincheckbox').prop("checked","checked");
    }
    initialLoad = false;
}

$(function(){
    iniFrame();
    asideMenu();
    initialMapLoad();
});
window.root = root;
window.dropbox = dropbox;
window.map = map;
window.params = params;
window.initialLoad = initialLoad;
window.setHeaderHeight = setHeaderHeight;
window.iniFrame = iniFrame;
window.getAllSelectedCheckboxes = getAllSelectedCheckboxes;
window.asideMenu = asideMenu;
window.initialMapLoad = initialMapLoad;
}.call(window, window);